import { Reducer } from "redux";

import { LanguageMasterResponse } from "../models/api/Master";
import { LanguageDispatchTypes } from "../models/dispatchTypes/Master";
import { LanguageMasterActionDispatchTypes } from "../constants/Master";

export const initialState: LanguageMasterResponse = {
  loading: false,
  response: [],
  error: null,
};

const MasterLanguageReducer: Reducer<
  LanguageMasterResponse,
  LanguageDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_RESET: {
      return {
        ...initialState,
      };
    }
  }
  return state;
};

export default MasterLanguageReducer;